import { useStore } from 'dg-web-shared/lib/Flux';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';
import { CustomerAccountType } from '../../../api/CustomerAccountType';
import * as MetaTexts from '../i18n/MetaTexts';
import * as MetaServerState from '../state/MetaServerState';
import { FieldItemBlock } from '../../root/components/ItemBlock';

export function AccountNr() {
    const { storeState } = useStore(store => ({
        metaServer: new MetaServerState.StateSlice(store).state,
    }));
    const { language } = useLanguage();

    const texts = MetaTexts.accountNr[language];

    return (
        <FieldItemBlock
            label={
                texts.AccountNr() +
                ' (' +
                getAccountInfo(
                    storeState.metaServer.data.customerAccountType,
                    texts,
                ) +
                ')'
            }
            content={storeState.metaServer.data.customerNr.toString()}
            onClick={null}
        />
    );
}

function getAccountInfo(
    customerAccountType: CustomerAccountType,
    texts: MetaTexts.AccountNrTexts,
): string {
    if (customerAccountType === CustomerAccountType.PRIVATE) {
        return texts.PrivateAccount();
    }

    return texts.CompanyAccount();
}
